import type { GetApiV1ThreeLetterCodePartnerAdminsContractPlansId200 } from '@fukuri-admins/apis/client/gen/model';
import { getThreeLetterCode } from '@fukuri-admins/utils/common/cookies';
import { useGetPartnerAdminsContractPlan } from '~/features/ContractPlanDetail/hooks/useGetPartnerAdminsContractPlan';

type Args = {
  /** 契約プラン ID */
  planId: number;
};

type IUseContractPlanDetailHeader = (args: Args) => {
  state: {
    /** 契約プラン詳細データ */
    contractPlan: GetApiV1ThreeLetterCodePartnerAdminsContractPlansId200;
  };
};

/**
 * 契約プラン詳細ヘッダーの状態を管理するフック
 *
 * - ContractPlanDetail と同じ API hook を共有する（SWR が dedupe するため二重リクエストにならない）
 * - threeLetterCode を Cookie から取得し、API hook に渡す
 */
export const useContractPlanDetailHeader: IUseContractPlanDetailHeader = ({ planId }) => {
  const threeLetterCode = getThreeLetterCode() ?? '';

  const { data: contractPlan } = useGetPartnerAdminsContractPlan({
    threeLetterCode,
    planId,
  });

  return {
    state: { contractPlan },
  };
};
